import EventOutlined from '@mui/icons-material/EventOutlined';
import { isIsoDate } from 'framework/utils/hooks/useDateService';
import { isoDate } from '../../format/pieces';
import { s } from '../../format/schema';
import { defineFieldType, formatMessageSetting } from '../card';
import { FormatMessageSettingsPanel } from '../shared/FormatMessageSettingsPanel';
import { DatepickerInput } from './FillInput';

export const datepicker = defineFieldType({
  type: 'datepicker',
  name: 'Date picker',
  valueKind: 'date',
  settings: s.strictObject({ ...formatMessageSetting }),
  defaults: {},
  value: isoDate.nullable(),
  emptyValue: null,
  hasDefaultValue: true,
  validations: ['required', 'range', 'unique'],
  operators: [
    'isFilled',
    'isEmpty',
    'equals',
    'notEquals',
    'lessThan',
    'lessThanOrEqual',
    'greaterThan',
    'greaterThanOrEqual',
  ],
  palette: [
    {
      name: 'Date picker',
      tooltip: 'A date without time',
      group: 'Number, date and file',
      icon: EventOutlined,
    },
  ],
  isEmpty: value => value === null,
  quantity: value => value,
  comparable: value => (isIsoDate(value) ? value : ''),
  builtInCheck: () => 'realDate',
  FillInput: DatepickerInput,
  fillLabel: () => 'outlined',
  settingsPanel: { at: 'settings', Panel: FormatMessageSettingsPanel },
});
